<template>

    <div class="bg" :class="playerId==0?'bg_1':'bg_2'">
                <div class="top" v-if="playerId!=0">
                    <div class="left">
                        <h1>{{name}}</h1>
                        <h2>{{hos}}</h2>
                        <h1 style="color: red" v-if="score!=0">得分：{{score}}</h1>
                    </div>
                    <div class="right">
                        <img :src="qrCode">
                        <h2>{{countdown}}</h2>
                    </div>
                </div>
                <div class="down" v-if="playerId!=0">
                    <span>{{hint}}</span>
                </div>
    </div>
</template>

<script>
    import {getVotePlayer,getScore} from "@/assets/js/api";

    export default {
        data(){
            return {
                name: "",
                hos: "",
                second:60,
                hint:"请给选手投票打分",
                countdown:"",
                id:"",
                playerId: 0,
                qrCode:"",
                score:0
            }
        },
        methods:{
            timeCountDown(){
                clearInterval(this.id);//先删除定时器
                if(this.second<=0){
                    this.countdown = "已结束"
                    this.toGetScore(this.playerId);
                    return;
                }
                this.id= setInterval(()=>{
                    --this.second;
                    this.showTime(this.second);
                    if(this.second<=0){
                        this.countdown = "已结束"
                        this.toGetScore(this.playerId);
                        clearInterval(this.id);
                    }
                },1000)
            },
            showTime(second){
                var h;
                h  =   Math.floor(second/60);
                //计算秒
                //算法：取得秒%60的余数，既得到秒数
                second = second%60;
                //将变量转换为字符串
                h += '';
                second += '';
                //如果只有一位数，前面增加一个0
                h  =   (h.length==1)?'0'+h:h;
                second  =   (second.length==1)?'0'+second:second;
                this.countdown = h+':'+second
            },
            async toGetPlayer(playerId){
                this.score=0;
                const res = await getVotePlayer({playerId})
                console.info(res.data.data.countdown,"countdown==")

                if(res.data.success){
                    this.name = res.data.data.name
                    this.hos = res.data.data.hos
                    this.playerId = res.data.data.playerId
                    this.qrCode = res.data.data.qrCode

                    console.log(res.data.data.countdown,"countdown")
                    // this.toGetScore(this.playerId);
                    if(res.data.data.countdown!=null&&res.data.data.countdown!=''){
                        var date = new Date(res.data.data.countdown)
                        this.second = parseInt(date.getTime()/1000) + 60 - parseInt(new Date().getTime()/1000)
                        this.timeCountDown()
                    }else{
                        this.countdown = "未开始"
                    }

                }
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e.data)
                var da =e.data;
                this.toGetPlayer(da);
            },
            async toGetScore(playerId){
                const res = await  getScore({playerId})
                if(res.data.success){
                    this.score = res.data.data
                    console.log(this.score,"score===")
                }
            }

        },
        mounted(){
            this.initWebSocket();
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
    }
    .bg_1{
        background: #FFF url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/qkds/vote_bg.jpg") no-repeat;
    }
    .bg_2{
        background: #FFF url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/qkds/vote_bg_1.jpg") no-repeat;
    }


    .top{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-around;
        align-items: center;
        flex-grow: 2;
    }
    .left{
        margin-left: 200px;
    }
    .right{
        margin-right: 200px;
    }
    .down{
        flex-grow: 1;
    }

    h1{
        font-size: 50px;
    }
    h2{
        font-size: 35px;
    }
    span{
        font-size: 20px;
    }
    img{
        width: 250px;
        height: 250px;
    }
</style>